const MAX_BANNER_WIDTH = 375;

export default class WebToAppBanner {
  constructor() {
    this.getElement();
  }

  init() {
    this.setMagicURL();
  }

  getElement() {
    this.imgs = Array.prototype.slice.call(document.querySelectorAll('.js-w2a-banner-image'));
  }

  setMagicURL() {
    this.imgs.forEach((el) => {
      const imgWidth = Math.min(el.parentNode.clientWidth, MAX_BANNER_WIDTH);
      const prefferedSize = Math.round(imgWidth * window.devicePixelRatio);

      el.addEventListener('load', () => {
        el.style.visibility = 'visible';
      }, true);

      el.setAttribute('src', `${el.dataset.src}=s${prefferedSize}`);
    });
  }
}
